module.exports = __webpack_public_path__ + "static/media/pusins_fyfe_solmonte.dd4787a9.jpg";